var $ = require('jquery');

/**
 *  render_map
 *
 *  This function will render a Google Map onto the selected jQuery element
 *
 *  @type    function
 *  @date    8/11/2013
 *  @since    4.3.0
 *
 *  @param    $el (jQuery element)
 *  @return    n/a
 */

function render_map($el) {
    var $markers = $el.find('.marker');

    var styles =
        [{
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#333"
                }
            ]
        }, {
            "featureType": "administrative.country",
            "elementType": "all",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "administrative.country",
            "elementType": "geometry",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "administrative.locality",
            "elementType": "all",
            "stylers": [{"visibility": "simplified"}, {"saturation": "-100"}, {"lightness": "0"}]
        }, {
            "featureType": "administrative.neighborhood",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "administrative.land_parcel",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{"visibility": "simplified"}, {"gamma": "0.00"}, {"lightness": "74"}]
        }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{"color": "#ffffff"}]
        }, {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{"visibility": "simplified"}, {"color": "#A07951"}, {"saturation": "-15"}, {"lightness": "40"}, {"gamma": "1.25"}]
        }, {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "transit",
            "elementType": "labels",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "transit",
            "elementType": "labels.icon",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [{"color": "#A07951"}, {"lightness": "80"}]
        }, {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [{"color": "#e5e5e5"}]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{"color": "#efefef"}]
        }, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{"color": "#02457C"}, {"visibility": "on"}]
        }];

    var styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"}),
        centerMap = '';

    $markers.each(function () {
        centerMap = new google.maps.LatLng($(this).attr('data-lat'), $(this).attr('data-lng'))
    });

    var mapOptions = {
        center: centerMap,
        zoom: 5,
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style'],
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL
        },
        scaleControl: false,
        mapTypeControl: false,
        panControl: false,
        overviewMapControl: false,
        streetViewControl: false,
        disableDoubleClickZoom: true,
        draggable: false,
        scrollwheel: false
    };

    // create map
    var map = new google.maps.Map($el[0], mapOptions);
    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {
        add_marker($(this), map, $(this).attr('data-location'));
    });

    // center map
    center_map(map);

}

/**

 *  add_marker
 *
 *  This function will add a marker to the selected Google Map
 *
 *  @type    function
 *  @date    8/11/2013
 *  @since    4.3.0
 *
 *  @param    $marker (jQuery element)
 *  @param    map (Google Map object)
 *  @return    n/a
 */

function add_marker($marker, map, location) {
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

    var icon = {
        url: $marker.attr('data-marker-image'), // url
        scaledSize: new google.maps.Size(27, 35), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(17, 0) // anchor
    };

    // create marker
    var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: icon,
        draggable: false
    });

    var infowindow = new google.maps.InfoWindow({
        disableAutoPan: true,
        isHidden:false,
        closeBoxURL: "",
        pane: "mapPane",
        enableEventPropagation: true
    });

    google.maps.event.addListener(marker, 'click', (function () {
        infowindow.setContent(location);
        infowindow.open(map, marker);
    }));

    // add to array
    map.markers.push(marker);
}

/**
 *  center_map
 *
 *  This function will center the map, showing all markers attached to this map
 *
 *  @type    function
 *  @date    8/11/2013
 *  @since    4.3.0
 *
 *  @param    map (Google Map object)
 *  @return    n/a
 */

function center_map(map) {
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng);

    });

    // only 1 marker?
    if (map.markers.length == 1) {
        // set center of map
        map.setCenter(bounds.getCenter());
        map.setZoom(17);
    }
    else {
        // fit to bounds
        map.fitBounds(bounds);
    }

}

/**
 *
 *  This function will render each map
 *
 *  @type    function
 *  @date    8/11/2013
 *  @since    5.0.0
 *
 *  @param    n/a
 *  @return    n/a
 */

module.exports = {
    init: function ($container) {
        render_map($container);
    }
};